import React, { createContext, useContext, useEffect, useState } from 'react'
import axios from 'axios'

export const AuthContext = createContext()
export const VenueContext = createContext(null)

export function useAuth() {
  return useContext(AuthContext)
}

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [loading, setLoading]           = useState(true)

  // on mount, ask the backend if our HttpOnly cookie is still valid
  useEffect(() => {
    axios
      .get('https://api.bestday2marry.com/check_user_session/', {
        withCredentials: true,      // ← send HttpOnly cookie
      })
      .then(() => {
        setIsAuthenticated(true)
      })
      .catch(() => {
        setIsAuthenticated(false)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  // call after your sign-in flow so we refresh that flag
  const login = () => {
    setIsAuthenticated(true)
  }

  const logout = async () => {
    try {
      await axios.post(
        "https://api.bestday2marry.com/logout/",
        {},
        { withCredentials: true }
      )
    } catch(err) {
      console.error("Logout request failed", err)
    } finally {
      setIsAuthenticated(false)
    }
  }

  // while we’re waiting on that first check, don’t render children
  if (loading) return <div>Loading…</div>

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}